import React from 'react';
import { FadeIn } from './FadeIn';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-164">
      <div className="max-w-3xl mx-auto" data-id="element-165">
        <FadeIn data-id="element-166">
          <div className="bg-green-mint/20 rounded-3xl p-8 md:p-12 border border-green-mint/40 relative overflow-hidden" data-id="element-167">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-lime/10 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-168"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-green-deep/5 rounded-full blur-2xl -ml-10 -mb-10" data-id="element-169"></div>

            <div className="relative z-10" data-id="element-170">
              <h2 className="font-heading font-bold text-2xl md:text-4xl text-green-deep mb-2" data-id="element-171">
                🌿 EL MECANISMO QUE LO CAMBIA TODO
              </h2>
              <p className="text-green-deep/80 font-semibold text-lg md:text-xl mb-8" data-id="element-172">
                El Protocolo del Intestino Comandante
              </p>

              <div className="space-y-6 text-text-main font-body text-base md:text-lg leading-relaxed" data-id="element-173">
                <p data-id="element-174">
                  Cuando le dás a tu hijo los alimentos correctos, en el orden
                  correcto, en los momentos correctos del día —
                </p>

                <p className="bg-white/60 p-4 rounded-xl font-medium" data-id="element-175">
                  Su intestino produce{' '}
                  <strong className="text-green-deep" data-id="element-176">
                    38 billones de bacterias defensoras
                  </strong>{' '}
                  entrenadas para reconocer virus, bloquear su adhesión a las
                  células, reducir inflamación y acelerar la recuperación.
                </p>

                <div className="pt-4 border-t border-green-mint/50" data-id="element-177">
                  <p className="font-heading font-bold text-xl md:text-2xl text-orange-warm text-center" data-id="element-178">
                    Eso no se consigue en una farmacia.
                  </p>
                  <p className="font-heading font-bold text-2xl md:text-3xl text-green-deep text-center mt-2" data-id="element-179">
                    Se consigue en la verdulería.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}